import { render, staticRenderFns } from "./LegendsPreview.vue?vue&type=template&id=0fd9f7f1&"
import script from "./LegendsPreview.vue?vue&type=script&lang=js&"
export * from "./LegendsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports